import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { productionLogger } from '@/utils';

/**
 * Component to validate and track product link integrity
 * Helps identify broken product links in production
 */
export const ProductLinkValidator = () => {
  const location = useLocation();
  

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Validate product URL patterns
    if (currentPath.startsWith('/products/') || currentPath.startsWith('/shopify-product/')) {
      const pathParts = currentPath.split('/');
      const identifier = pathParts[2];
      
      // Basic validation
      if (!identifier || identifier.length < 3) {
        productionLogger.warn('Invalid product identifier:', identifier);
        
        // In development, show toast for debugging
        if (process.env.NODE_ENV === 'development') {
          toast.error(`Product identifier "${identifier}" appears invalid`);
        }
      }
      
      // Check for common URL issues
      if (identifier.includes('%20')) {
        productionLogger.warn('Product URL contains encoded spaces:', currentPath);
      }
      
      if (identifier.includes('undefined') || identifier.includes('null')) {
        productionLogger.error('Product URL contains undefined/null values:', currentPath);
        
        if (process.env.NODE_ENV === 'development') {
          toast.error("Product URL contains undefined values");
        }
      }
    }
  }, [location.pathname, toast]);

  // This component doesn't render anything
  return null;
};

export default ProductLinkValidator;